import Vue from 'vue'
import store from './components/store.js'
import App from './App'
import cover from './components/cover.vue'
import q1 from './components/q1.vue'
import q2 from './components/q2.vue'
import q3 from './components/q3.vue'
import q4 from './components/q4.vue'
import q5 from './components/q5.vue'
import q6 from './components/q6.vue'
import q7 from './components/q7.vue'
import q8 from './components/q8.vue'
import q9 from './components/q9.vue'
import q10 from './components/q10.vue'
import result from './components/result.vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

App.components = {
  cover: cover,
  q1: q1,
  q2: q2,
  q3: q3,
  q4: q4,
  q5: q5,
  q6: q6,
  q7: q7,
  q8: q8,
  q9: q9,
  q10: q10,
  result: result
}
var answerObj = {testNo: 1}
/* eslint-disable no-new */
new Vue({
  el: 'body',
  data () {
    return {
      currentView: 'cover',
      step: 0,
      testNo: 1
    }
  },
  components: { App },
  events: {
    changeView: function (view, score, answer) {
      Object.assign(answerObj, answer)
      store.score += score
      this.step += 1
      if (view === 'result') {
        this.$http.jsonp('http://m.creditcard.com.cn/apply/action/applyForCreditCardEvaluate.html', {params: answerObj})
        var url = ''
        switch (!0) {
          case store.score < 25:
            url = 'http://sites.wacai.com/973/index.html'
            break
          case store.score < 55:
            url = 'http://sites.wacai.com/974/index.html'
            break
          case store.score < 65:
            url = 'http://sites.wacai.com/975/index.html'
            break
          case store.score < 75:
            url = 'http://sites.wacai.com/976/index.html'
            break
          case store.score < 85:
            url = 'http://sites.wacai.com/977/index.html'
            break
          case store.score < 95:
            url = 'http://sites.wacai.com/978/index.html'
            break
          case store.score > 95:
            url = 'http://sites.wacai.com/979/index.html'
            break
        }
        window.location.href = url
        return false
      }
      this.currentView = view
    },
    redo () {
      store.score = 0
      this.step = 0
      this.testNo += 1
      answerObj = { testNo: this.testNo }
      this.currentView = 'cover'
    }
  }
})



/** WEBPACK FOOTER **
 ** ./src/main.js
 **/